import { FormProvider } from 'react-hook-form'
import { useState } from 'react'

import { Button, Card, Form, Stack, Toast } from '@shopify/polaris'

import { useAccountSettingsForm } from '../hooks/useAccountSettingsForm'
import { segment } from '../util/createSegmentPicker'
import { getTranslation } from '../util/getTranslation'
import { SettingsLanguage } from './SettingsLanguage'
import { SettingsPaymentLabel } from './SettingsPaymentLabel'
import { CSVExportDialog } from './CSVExportDialog'
import { TAccountActivationStatus } from '@sga/shopify-payments-types'
import { getGPWebPayLanguageOptions } from '../util/getLanguageOptions'

type TProps = {
  goBack: () => any
  status: TAccountActivationStatus
}
GPWebPayAccountSettings.segment = segment('gpwebpay')

export function GPWebPayAccountSettings({ goBack, status }: TProps) {
  const { form, saveStatus, setSaveStatus, onSubmit } = useAccountSettingsForm((api, formValues) => api.saveConfig(formValues))
  const [csvDialogOpen, setCsvDialogOpen] = useState(false)

  if (status === 'new') {
    // Don't bother user with too much stuff initially
    return null
  }

  return (
    <>
      <Card title={getTranslation('settings.gateway_settings')}>
        <FormProvider {...form}>
          <Form onSubmit={onSubmit}>
            <SettingsLanguage languages={getGPWebPayLanguageOptions()} />
            <SettingsPaymentLabel />
            <Card.Section>
              <Stack distribution="equalSpacing">
                <Button onClick={goBack}>{getTranslation('common.go_back')}</Button>
                <Button primary submit disabled={form.formState.isSubmitting}>
                  {getTranslation('common.save_settings')}
                </Button>
              </Stack>
            </Card.Section>
          </Form>
        </FormProvider>
      </Card>

      {(status === 'active' || status === 'verified') && (
        <Card title={getTranslation('gpwebpay.csv_export_title')} sectioned>
          <Stack vertical spacing="tight">
            <p>
              {getTranslation('gpwebpay.csv_export_description')}
            </p>
            <Stack>
              <Button onClick={() => setCsvDialogOpen(true)}>
                {getTranslation('gpwebpay.export_to_csv')}
              </Button>
            </Stack>
          </Stack>
        </Card>
      )}

      <CSVExportDialog 
        open={csvDialogOpen} 
        onClose={() => setCsvDialogOpen(false)} 
      />

      {saveStatus === 'success' && (
        <Toast
          content={getTranslation('common.settings_saved')}
          onDismiss={() => setSaveStatus('submit')}
        />
      )}
      {saveStatus === 'failure' && (
        <Toast
          content={getTranslation('common.saving_failed')}
          error
          onDismiss={() => setSaveStatus('submit')}
        />
      )}
    </>
  )
}
